import Tippy from "@tippyjs/react";
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from "../../../../../_metronic/layout/core";
import { GetGarantiasBovedaAuthorizationList, GetGarantiasBovedaStateList, GetGarantiasToRecepcion, SaveGarantiaBoveda } from "../../../../api/Api";
import PermissionsGate from "../../../../api/PermissionsGate";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import WrappedAgTable from "../../../../Components/Table/WrappedAgTable";
import { createCustomDateFilterParams } from "../../../../Components/Utils/Utils";
import { SCOPES } from "../../../../config/permissions-map";
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { Unauthorized } from "../../../Global/unauthorized";
import { GARANTIA_TIPO } from "../../../Utils/Constants";
import './ListadoGarantiaBoveda.css';
import CardEx from "../../../../Components/Cards/CardEx";
import numeral from 'numeral';
import cogoToast from "cogo-toast";

export default function ListadoGarantiasBoveda({ title }) {

  const { data: garantiasToBovedaList, refetch: refetchGetGarantiasToBoveda } = useQuery("getGarantiasToBoveda", () => GetGarantiasToRecepcion(
    {
      "tipo_garantia": null,
      "filter_by_ubicacion": true,
      "filter_by_only_tipos_garantia_definida": true
    }
  ));

  useEffect(() => {
    console.info(garantiasToBovedaList, "garantiasToBovedaList");
  }, [garantiasToBovedaList])

  const [isFinishSaveBoveda, setIsFinishSaveBoveda] = useState(false);
  const [isLoandingSaveBoveda, setIsLoandingSaveBoveda] = useState(false);
  const [showSaveBovedaModal, setShowSaveBovedaModal] = useState(false);
  const [stateOptionList, setStateOptionList] = useState([]);
  const [authorizationOptionList, setAuthorizationOptionList] = useState([]);

  const [bovedaStateSelected, setBovedaStateSelected] = useState(null);
  const [bovedaAuthorizationSelected, setBovedaAuthorizationSelected] = useState(null);
  const [file, setFile] = useState("");
  const [letraNumero, setLetraNumero] = useState("");
  const [messageErrorSave, setMessageErrorSave] = useState("");

  const user = useGetUser();
  const queryClient = useQueryClient();

  const idGarantiaDetalle = useRef(null);
  const typeCodeGarantia = useRef("");
  const nroDocumento = useRef("");
  const stateCode = useRef("");
  const authorizationCode = useRef("");

  const transformArrayOptions = useCallback((array) => {
    return array.map(item => ({
      value: item.codigo,
      label: item.descripcion
    }));
  }, []);

  const callService = useCallback(async (key, service) => {
    const result = await queryClient.fetchQuery(key, service);
    if (result.success) {
      return transformArrayOptions(result.data);
    } else {
      return [];
    }
  }, [queryClient, transformArrayOptions]);

  const handleShowSaveBovedaModal = useCallback(async (props) => {
    setIsLoandingSaveBoveda(true);
    setShowSaveBovedaModal(true);

    idGarantiaDetalle.current = props.data.detalle_garantia.id_garantia_detalle;
    typeCodeGarantia.current = props.data.detalle_garantia.tipo_garantia.codigo;

    stateCode.current = props.data.detalle_garantia.ubicacion.codigo_estado;
    authorizationCode.current = props.data.detalle_garantia.ubicacion.codigo_autorizacion;

    if (props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
      nroDocumento.current = props.data.detalle_garantia.nro_carta_fianza;
    } else {
      nroDocumento.current = props.data.detalle_garantia.nro_operacion;
    }

    const bovedaStateList = await callService('getGarantiasBovedaStateList', GetGarantiasBovedaStateList);
    const bovedaAuthorizationList = await callService('getGarantiasBovedaAuthorizationList', GetGarantiasBovedaAuthorizationList);

    setFile(props.data.detalle_garantia.ubicacion.file ?? "");
    setLetraNumero(props.data.detalle_garantia.ubicacion.letra_numero ?? "");
    setStateOptionList(bovedaStateList);
    setAuthorizationOptionList(bovedaAuthorizationList);

  }, [callService]);


  useEffect(() => {
    if (stateOptionList.length > 0 && authorizationOptionList.length > 0) {
      if (stateCode.current && authorizationCode.current) {
        setBovedaStateSelected(stateOptionList.find(element => element.value === stateCode.current));
        setBovedaAuthorizationSelected(authorizationOptionList.find(element => element.value === authorizationCode.current));;
      }
      setIsLoandingSaveBoveda(false);
    } else {
      setIsLoandingSaveBoveda(false);
    }

  }, [authorizationOptionList, stateOptionList])

  const headerGarantiasToBoveda = useMemo(() => [
    {
      headerName: 'Id',
      field: 'detalle_garantia.id_garantia_detalle',
      pinned: 'left',
      width: 80,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Acciones',
      width: 100,
      filter: false,
      pinned: 'left',
      sortable: false,
      cellRenderer: (props) => props.data ? (
        <Tippy theme='light-border' content="Guardar en Bóveda">
          <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
            onClick={() => handleShowSaveBovedaModal(props)}>
            <i className="fi fi-rr-hand-holding-box"></i>
          </button>
        </Tippy>
      ) : <></>
    },
    {
      headerName: 'Contrato',
      field: 'garantia.nro_contrato',
      width: 120,
      filter: 'agTextColumnFilter',
      pinned: 'left',

    },
    {
      headerName: 'Tipo',
      field: 'detalle_garantia.tipo_garantia.nombre',
      width: 100
    },
    {
      headerName: 'Nro Carta Fianza',
      field: 'detalle_garantia.nro_carta_fianza',
      width: 140,
      filter: 'agTextColumnFilter'
    },
    // {
    //   headerName: 'Nro Operación',
    //   field: 'detalle_garantia.nro_operacion',
    //   width: 130,
    //   filter: 'agTextColumnFilter'
    // },
    {
      headerName: 'RUC',
      field: 'garantia.ruc',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Razon Social',
      field: 'garantia.razon_social',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'File',
      field: 'detalle_garantia.ubicacion.file',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Letra Número',
      field: 'detalle_garantia.ubicacion.letra_numero',
      width: 120,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Estado',
      field: 'detalle_garantia.ubicacion.descripcion_estado',
      width: 100
    },
    {
      headerName: 'Autorización',
      field: 'detalle_garantia.ubicacion.descripcion_autorizacion',
      width: 100,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: 'Fecha Registro',
      field: 'detalle_garantia.ubicacion.updated_date',
      width: 180,
      filter: 'agDateColumnFilter',
      filterParams: createCustomDateFilterParams,
      valueFormatter: function (params) {
        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
      }
    },
    {
      headerName: 'Importe',
      field: 'detalle_garantia.importe',
      width: 100,
      filter: 'agTextColumnFilter',
      valueFormatter: function (params) {
        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
      },
    },
    {
      headerName: 'Moneda',
      field: 'garantia.moneda.codigo',
      width: 90,
    },
    {
      headerName: 'Banco',
      field: 'detalle_garantia.banco.codigo',
      width: 100
    },
    {
      headerName: 'F.Venc. Carta Fianza',
      width: 180,
      field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
      filter: 'agDateColumnFilter',
      filterParams: createCustomDateFilterParams,
      valueFormatter: function (params) {
        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
      }
    },


  ], [handleShowSaveBovedaModal]);

  const agGridLista = useMemo(() => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 10,
      floatingFilter: true,
      enableRowGroup: true
    },
    columnDefs: headerGarantiasToBoveda,
    rowData: garantiasToBovedaList?.data,
    pagination: true,
    rowGroupPanelShow: 'always',
    domLayout: "normal",
    autoGroupColumnDef: {
      headerName: 'Grupo',
      filter: 'agGroupColumnFilter'
    }
  }), [headerGarantiasToBoveda, garantiasToBovedaList?.data]);

  const handleConfirmSaveBovedaModal = useCallback(() => {
    setIsFinishSaveBoveda(false);
    setIsLoandingSaveBoveda(true);

    const obj = {
      "id_garantia_detalle": idGarantiaDetalle.current,
      "file": file,
      "letra_numero": letraNumero,
      "codigo_estado": bovedaStateSelected.value,
      "codigo_autorizacion": bovedaAuthorizationSelected.value,
      "updated_by": user.email
    }

    queryClient.fetchQuery('saveGarantiaBoveda', () => SaveGarantiaBoveda(obj))
      .then((result) => {
        if (result.success) {
          refetchGetGarantiasToBoveda();
        } else {
          setMessageErrorSave("ERRORRR!!!!!")
        }
      }).catch((err) => {
        setMessageErrorSave("ERRORRR!!!!!")
      }).finally(() => {
        setIsFinishSaveBoveda(true);
        setIsLoandingSaveBoveda(false);
      });

  }, [bovedaAuthorizationSelected, bovedaStateSelected, file, letraNumero, queryClient, refetchGetGarantiasToBoveda, user.email]);

  const handleCloseSaveBovedaModal = useCallback((params) => {
    setIsFinishSaveBoveda(false);
    setIsLoandingSaveBoveda(false);
    setStateOptionList([]);
    setAuthorizationOptionList([]);
    setBovedaStateSelected(null);
    setBovedaAuthorizationSelected(null);
    setFile("");
    setLetraNumero("");
    setMessageErrorSave("");
    idGarantiaDetalle.current = null;
    typeCodeGarantia.current = "";
    nroDocumento.current = "";
    stateCode.current = "";
    authorizationCode.current = "";

  }, []);

  const validationButtonConfirm = useCallback(() => {
    return !bovedaStateSelected || !bovedaAuthorizationSelected || !file || !letraNumero
  }, [bovedaAuthorizationSelected, bovedaStateSelected, file, letraNumero])

  const breadcrumbs = [
    { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Garantías", path: "", isActive: false, isSeparator: false },
  ];

  return (
    <>
      <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_UBICACION_CARTA_FIANZA]} >
        <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
        <CardEx titleParent={title} 
          title={"Listado de Garantías"} 
          isAvailableMaximized={true}
          isAvailableBreadcrumbs={true}
          isAvailableRefetch={true}
          breadcrumbs={breadcrumbs} 
          height={"700px"} 
          onRefetch={async () => {
            await refetchGetGarantiasToBoveda();
            cogoToast.success('Registros actualizado satisfactoriamente!', {
              //hideAfter: 0,
              heading: 'Listado de Garantías',
              position: 'top-right'
            });
          }}>

          <WrappedAgTable
            titleExcel={"listado_de_garantias_boveda"}
            {...agGridLista}
          >
          </WrappedAgTable>
        </CardEx>

        <ConfirmWithLoader
          showModal={showSaveBovedaModal}
          setShowModal={setShowSaveBovedaModal}
          title={"Bóveda de Garantía"}
          isLoading={isLoandingSaveBoveda}
          isFinish={isFinishSaveBoveda}
          textButton={"Guardar"}
          textButtonCancel={"Cerrar"}
          hideContentInLoading={false}
          hideActionAfterConfirm={false}
          onConfirm={handleConfirmSaveBovedaModal}
          onClose={handleCloseSaveBovedaModal}
          disabledConfirmButton={validationButtonConfirm()}>

          {!isLoandingSaveBoveda && isFinishSaveBoveda && (
            messageErrorSave ? (
              <Alert key='error' variant='primary' className='mb-8'>
                <b>Error</b>: {messageErrorSave}
              </Alert>
            ) : (
              <Alert key='info' variant='success' className='mb-8'>
                {typeCodeGarantia.current === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                  <>
                    <b>Garantía Guardada</b>: Se ha guardado en la bóveda la Carta Fianza <b>{nroDocumento.current}</b> ha sido guardada exitosamente.
                  </>
                ) : (
                  <>
                    <b>Garantía Guardada</b>: Se ha guardado en la bóveda la Garantía en Efectivo <b>Nro {nroDocumento.current}</b> ha sido guardada exitosamente.
                  </>
                )}
              </Alert>
            )
          )}

          <div className='container'>
            <div className='row'>
              <div className='col-12 d-flex align-items-center justify-content-end'>
                {typeCodeGarantia.current === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                  <label className="fw-bold fs-6 mb-0 me-2">Nro Carta Fianza:</label>
                ) : (
                  <label className="fw-bold fs-6 mb-0 me-2">Nro Operación:</label>
                )}
                <span>{nroDocumento.current}</span>
              </div>
            </div>

            <div className="row mt-6 container-form">
              <div className="col-12 d-flex align-items-center">
                <label className="fw-bold fs-6 me-4 label-form text-end">File:</label>
                <input type="text"
                  className="form-control form-control-solid flex-grow-1 w-auto"
                  value={file}
                  onChange={(e) => setFile(e.target.value)}
                />
              </div>
              <div className="col-12 d-flex align-items-center">
                <label className="fw-bold fs-6 me-4 label-form text-end">Letra y Número:</label>
                <input type="text"
                  className="form-control form-control-solid flex-grow-1 w-auto"
                  value={letraNumero}
                  onChange={(e) => setLetraNumero(e.target.value)}
                />
              </div>
              <div className="col-12 d-flex align-items-center">
                <label className="fw-bold fs-6 me-4 label-form text-end">Estado:</label>
                <Select
                  classNamePrefix='filter'
                  components={makeAnimated()}
                  value={bovedaStateSelected}
                  options={stateOptionList}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  placeholder="Selecciona"
                  className="flex-grow-1 w-auto"
                  isSearchable={false}
                  onChange={(value) => {
                    setBovedaStateSelected(value);
                  }}
                />
              </div>

              <div className="col-12 d-flex align-items-center">
                <label className="fw-bold fs-6 me-4 label-form text-end">Autorización:</label>
                <Select
                  classNamePrefix='filter'
                  components={makeAnimated()}
                  value={bovedaAuthorizationSelected}
                  options={authorizationOptionList}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  placeholder="Selecciona"
                  className="flex-grow-1 w-auto"
                  isSearchable={false}
                  onChange={(value) => {
                    setBovedaAuthorizationSelected(value);
                  }}

                />
              </div>
            </div>

          </div>
        </ConfirmWithLoader>
      </PermissionsGate>
    </>
  )
}